'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'pipe-smoking';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e3c4';
var svgPathData = 'M0 256l0 90.4c0 91.5 74.1 165.6 165.6 165.6 56.3 0 108.8-28.6 139.3-76l136.3-212-117.9 0-67.2 96 0-64c0-17.7-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32zm356.8-80l115.2 0 72-112 64 0c17.7 0 32-14.3 32-32S625.7 0 608 0L513.3 0c-20.9 0-40.5 10.2-52.4 27.3L356.8 176z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPipeSmoking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;